import React from 'react';
import { useApp } from '../context/AppContext';

export default function NoDataPage() {
  const { config } = useApp();
  const homeUrl = `${config.viewUrl}?date=${config.date}`;

  return (
    <div className="fixed top-0 left-0 w-full h-full overflow-none bg-white grid grid-cols-1 grid-rows-1 items-center justify-center text-center">
      <div>
        <div>404 - Not Found</div>
        <button onClick={() => (window.location.href = homeUrl)}>Return to Home</button>
      </div>
    </div>
  );
}
